module.exports = __webpack_public_path__ + "static/media/gb-wls.ca26c224.svg";